const textFieldLogin = {
  password: 'Password'
};

export default textFieldLogin;
